"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CSV: ['.csv'],
  ZIP: ['.zip'],
  PDF: ['.pdf']
};
exports.default = _default;